import axios from './BaseService';

const API_URL = process.env.REACT_APP_API_URL;

export async function getEmailNewsUsers() {
    const url = `${API_URL}/email-news/users`;
    const response = await axios.get(url);
    return response.data;
}

export async function sendEmailNews({ sendToAll, userId, subject, message }) {
    const url = `${API_URL}/email-news/send`;
    const response = await axios.post(url, { sendToAll, userId, subject, message });
    return response.data;
}
